"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BuilderGroup = _interopRequireDefault(require("../../render/canvas/BuilderGroup.js"));

var _Layer = _interopRequireDefault(require("./Layer.js"));

var _ExecutorGroup = _interopRequireDefault(require("../../render/canvas/ExecutorGroup.js"));

var _ViewHint = _interopRequireDefault(require("../../ViewHint.js"));

var _hitdetect = require("../../render/canvas/hitdetect.js");

var _transform = require("../../transform.js");

var _extent = require("../../extent.js");

var _css = require("../../css.js");

var _vector = require("../vector.js");

var _array = require("../../array.js");

var _proj = require("../../proj.js");

var _util = require("../../util.js");

var _coordinate = require("../../coordinate.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/renderer/canvas/VectorLayer
 */


/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */
var CanvasVectorLayerRenderer =
/** @class */
function (_super) {
  __extends(CanvasVectorLayerRenderer, _super);
  /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */


  function CanvasVectorLayerRenderer(vectorLayer) {
    var _this = _super.call(this, vectorLayer) || this;
    /** @private */


    _this.boundHandleStyleImageChange_ = _this.handleStyleImageChange_.bind(_this);
    /**
     * @type {boolean}
     */

    _this.animatingOrInteracting_;
    /**
     * @private
     * @type {boolean}
     */

    _this.dirty_ = false;
    /**
     * @type {ImageData}
     */

    _this.hitDetectionImageData_ = null;
    /**
     * @type {Array<import("../../Feature.js").default>}
     */

    _this.renderedFeatures_ = null;
    /**
     * @private
     * @type {number}
     */

    _this.renderedRevision_ = -1;
    /**
     * @private
     * @type {number}
     */

    _this.renderedResolution_ = NaN;
    /**
     * @private
     * @type {import("../../extent.js").Extent}
     */

    _this.renderedExtent_ = (0, _extent.createEmpty)();
    /**
     * @private
     * @type {import("../../extent.js").Extent}
     */

    _this.wrappedRenderedExtent_ = (0, _extent.createEmpty)();
    /**
     * @private
     * @type {number}
     */

    _this.renderedRotation_;
    /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */

    _this.renderedCenter_ = null;
    /**
     * @private
     * @type {import("../../proj/Projection").default}
     */

    _this.renderedProjection_ = null;
    /**
     * @private
     * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
     */

    _this.renderedRenderOrder_ = null;
    /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */

    _this.replayGroup_ = null;
    /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */

    _this.replayGroupChanged = true;
    /**
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */

    _this.declutterExecutorGroup = null;
    /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */

    _this.clipping = true;
    return _this;
  }
  /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {import("rbush").default} [opt_declutterTree] Declutter tree.
   */


  CanvasVectorLayerRenderer.prototype.renderWorlds = function (executorGroup, frameState, opt_declutterTree) {
    var extent = frameState.extent;
    var viewState = frameState.viewState;
    var center = viewState.center;
    var resolution = viewState.resolution;
    var projection = viewState.projection;
    var rotation = viewState.rotation;
    var projectionExtent = projection.getExtent();
    var vectorSource = this.getLayer().getSource();
    var pixelRatio = frameState.pixelRatio;
    var viewHints = frameState.viewHints;
    var snapToPixel = !(viewHints[_ViewHint["default"].ANIMATING] || viewHints[_ViewHint["default"].INTERACTING]);
    var context = this.context;
    var width = Math.round(frameState.size[0] * pixelRatio);
    var height = Math.round(frameState.size[1] * pixelRatio);
    var multiWorld = vectorSource.getWrapX() && projection.canWrapX();
    var worldWidth = multiWorld ? (0, _extent.getWidth)(projectionExtent) : null;
    var endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
    var world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;

    do {
      var transform = this.getRenderTransform(center, resolution, rotation, pixelRatio, width, height, world * worldWidth);
      executorGroup.execute(context, 1, transform, rotation, snapToPixel, undefined, opt_declutterTree);
    } while (++world < endWorld);
  };
  /**
   * Render declutter items for this layer
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   */


  CanvasVectorLayerRenderer.prototype.renderDeclutter = function (frameState) {
    if (this.declutterExecutorGroup) {
      this.renderWorlds(this.declutterExecutorGroup, frameState, frameState.declutterTree);
    }
  };
  /**
   * Render the layer.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */


  CanvasVectorLayerRenderer.prototype.renderFrame = function (frameState, target) {
    var pixelRatio = frameState.pixelRatio;
    var layerState = frameState.layerStatesArray[frameState.layerIndex]; // set forward and inverse pixel transforms

    (0, _transform.makeScale)(this.pixelTransform, 1 / pixelRatio, 1 / pixelRatio);
    (0, _transform.makeInverse)(this.inversePixelTransform, this.pixelTransform);
    var canvasTransform = (0, _transform.toString)(this.pixelTransform);
    this.useContainer(target, canvasTransform, layerState.opacity, this.getBackground(frameState));
    var context = this.context;
    var canvas = context.canvas;
    var replayGroup = this.replayGroup_;
    var declutterExecutorGroup = this.declutterExecutorGroup;

    if ((!replayGroup || replayGroup.isEmpty()) && (!declutterExecutorGroup || declutterExecutorGroup.isEmpty())) {
      return null;
    } // resize and clear


    var width = Math.round(frameState.size[0] * pixelRatio);
    var height = Math.round(frameState.size[1] * pixelRatio);

    if (canvas.width != width || canvas.height != height) {
      canvas.width = width;
      canvas.height = height;

      if (canvas.style.transform !== canvasTransform) {
        canvas.style.transform = canvasTransform;
      }
    } else if (!this.containerReused) {
      context.clearRect(0, 0, width, height);
    }

    this.preRender(context, frameState);
    var viewState = frameState.viewState;
    var projection = viewState.projection; // clipped rendering if layer extent is set

    var clipped = false;
    var render = true;

    if (layerState.extent && this.clipping) {
      var layerExtent = (0, _proj.fromUserExtent)(layerState.extent, projection);
      render = (0, _extent.intersects)(layerExtent, frameState.extent);
      clipped = render && !(0, _extent.containsExtent)(layerExtent, frameState.extent);

      if (clipped) {
        this.clipUnrotated(context, frameState, layerExtent);
      }
    }

    if (render) {
      this.renderWorlds(replayGroup, frameState);
    }

    if (clipped) {
      context.restore();
    }

    this.postRender(context, frameState);
    var opacity = (0, _css.cssOpacity)(layerState.opacity);
    var container = this.container;

    if (opacity !== container.style.opacity) {
      container.style.opacity = opacity;
    }

    if (this.renderedRotation_ !== viewState.rotation) {
      this.renderedRotation_ = viewState.rotation;
      this.hitDetectionImageData_ = null;
    }

    return this.container;
  };
  /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise that resolves with an array of features.
   */


  CanvasVectorLayerRenderer.prototype.getFeatures = function (pixel) {
    return new Promise(
    /**
     * @param {function(Array<import("../../Feature").default|import("../../render/Feature").default>): void} resolve Resolver function.
     * @this {CanvasVectorLayerRenderer}
     */
    function (resolve) {
      if (!this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
        var size = [this.context.canvas.width, this.context.canvas.height];
        (0, _transform.apply)(this.pixelTransform, size);
        var center = this.renderedCenter_;
        var resolution = this.renderedResolution_;
        var rotation = this.renderedRotation_;
        var projection = this.renderedProjection_;
        var extent = this.wrappedRenderedExtent_;
        var layer = this.getLayer();
        var transforms = [];
        var width = size[0] * _hitdetect.HIT_DETECT_RESOLUTION;
        var height = size[1] * _hitdetect.HIT_DETECT_RESOLUTION;
        transforms.push(this.getRenderTransform(center, resolution, rotation, _hitdetect.HIT_DETECT_RESOLUTION, width, height, 0).slice());
        var source = layer.getSource();
        var projectionExtent = projection.getExtent();

        if (source.getWrapX() && projection.canWrapX() && !(0, _extent.containsExtent)(projectionExtent, extent)) {
          var startX = extent[0];
          var worldWidth = (0, _extent.getWidth)(projectionExtent);
          var world = 0;
          var offsetX = void 0;

          while (startX < projectionExtent[0]) {
            --world;
            offsetX = worldWidth * world;
            transforms.push(this.getRenderTransform(center, resolution, rotation, _hitdetect.HIT_DETECT_RESOLUTION, width, height, offsetX).slice());
            startX += worldWidth;
          }

          world = 0;
          startX = extent[2];

          while (startX > projectionExtent[2]) {
            ++world;
            offsetX = worldWidth * world;
            transforms.push(this.getRenderTransform(center, resolution, rotation, _hitdetect.HIT_DETECT_RESOLUTION, width, height, offsetX).slice());
            startX -= worldWidth;
          }
        }

        this.hitDetectionImageData_ = (0, _hitdetect.createHitDetectionImageData)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation);
      }

      resolve((0, _hitdetect.hitDetect)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
    }.bind(this));
  };
  /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */


  CanvasVectorLayerRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, matches) {
    var _this = this;

    if (!this.replayGroup_) {
      return undefined;
    }

    var resolution = frameState.viewState.resolution;
    var rotation = frameState.viewState.rotation;
    var layer = this.getLayer();
    /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */

    var features = {};
    /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */

    var featureCallback = function featureCallback(feature, geometry, distanceSq) {
      var key = (0, _util.getUid)(feature);
      var match = features[key];

      if (!match) {
        if (distanceSq === 0) {
          features[key] = true;
          return callback(feature, layer, geometry);
        }

        matches.push(features[key] = {
          feature: feature,
          layer: layer,
          geometry: geometry,
          distanceSq: distanceSq,
          callback: callback
        });
      } else if (match !== true && distanceSq < match.distanceSq) {
        if (distanceSq === 0) {
          features[key] = true;
          matches.splice(matches.lastIndexOf(match), 1);
          return callback(feature, layer, geometry);
        }

        match.geometry = geometry;
        match.distanceSq = distanceSq;
      }

      return undefined;
    };

    var result;
    var executorGroups = [this.replayGroup_];

    if (this.declutterExecutorGroup) {
      executorGroups.push(this.declutterExecutorGroup);
    }

    executorGroups.some(function (executorGroup) {
      return result = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, executorGroup === _this.declutterExecutorGroup && frameState.declutterTree ? frameState.declutterTree.all().map(function (item) {
        return item.value;
      }) : null);
    });
    return result;
  };
  /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   */


  CanvasVectorLayerRenderer.prototype.handleFontsChanged = function () {
    var layer = this.getLayer();

    if (layer.getVisible() && this.replayGroup_) {
      layer.changed();
    }
  };
  /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */


  CanvasVectorLayerRenderer.prototype.handleStyleImageChange_ = function (event) {
    this.renderIfReadyAndVisible();
  };
  /**
   * Determine whether render should be called.
   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */


  CanvasVectorLayerRenderer.prototype.prepareFrame = function (frameState) {
    var vectorLayer = this.getLayer();
    var vectorSource = vectorLayer.getSource();

    if (!vectorSource) {
      return false;
    }

    var animating = frameState.viewHints[_ViewHint["default"].ANIMATING];
    var interacting = frameState.viewHints[_ViewHint["default"].INTERACTING];
    var updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
    var updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();

    if (!this.dirty_ && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
      this.animatingOrInteracting_ = true;
      return true;
    }

    this.animatingOrInteracting_ = false;
    var frameStateExtent = frameState.extent;
    var viewState = frameState.viewState;
    var projection = viewState.projection;
    var resolution = viewState.resolution;
    var pixelRatio = frameState.pixelRatio;
    var vectorLayerRevision = vectorLayer.getRevision();
    var vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
    var vectorLayerRenderOrder = vectorLayer.getRenderOrder();

    if (vectorLayerRenderOrder === undefined) {
      vectorLayerRenderOrder = _vector.defaultOrder;
    }

    var center = viewState.center.slice();
    var extent = (0, _extent.buffer)(frameStateExtent, vectorLayerRenderBuffer * resolution);
    var renderedExtent = extent.slice();
    var loadExtents = [extent.slice()];
    var projectionExtent = projection.getExtent();

    if (vectorSource.getWrapX() && projection.canWrapX() && !(0, _extent.containsExtent)(projectionExtent, frameState.extent)) {
      // For the replay group, we need an extent that intersects the real world
      // (-180° to +180°). To support geometries in a coordinate range from -540°
      // to +540°, we add at least 1 world width on each side of the projection
      // extent. If the viewport is wider than the world, we need to add half of
      // the viewport width to make sure we cover the whole viewport.
      var worldWidth = (0, _extent.getWidth)(projectionExtent);
      var gutter = Math.max((0, _extent.getWidth)(extent) / 2, worldWidth);
      extent[0] = projectionExtent[0] - gutter;
      extent[2] = projectionExtent[2] + gutter;
      (0, _coordinate.wrapX)(center, projection);
      var loadExtent = (0, _extent.wrapX)(loadExtents[0], projection); // If the extent crosses the date line, we load data for both edges of the worlds

      if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) {
        loadExtents.push([loadExtent[0] + worldWidth, loadExtent[1], loadExtent[2] + worldWidth, loadExtent[3]]);
      } else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) {
        loadExtents.push([loadExtent[0] - worldWidth, loadExtent[1], loadExtent[2] - worldWidth, loadExtent[3]]);
      }
    }

    if (!this.dirty_ && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && (0, _extent.containsExtent)(this.wrappedRenderedExtent_, extent)) {
      if (!(0, _array.equals)(this.renderedExtent_, renderedExtent)) {
        this.hitDetectionImageData_ = null;
        this.renderedExtent_ = renderedExtent;
      }

      this.renderedCenter_ = center;
      this.replayGroupChanged = false;
      return true;
    }

    this.replayGroup_ = null;
    this.dirty_ = false;
    var replayGroup = new _BuilderGroup["default"]((0, _vector.getTolerance)(resolution, pixelRatio), extent, resolution, pixelRatio);
    var declutterBuilderGroup;

    if (this.getLayer().getDeclutter()) {
      declutterBuilderGroup = new _BuilderGroup["default"]((0, _vector.getTolerance)(resolution, pixelRatio), extent, resolution, pixelRatio);
    }

    var userProjection = (0, _proj.getUserProjection)();
    var userTransform;

    if (userProjection) {
      for (var i = 0, ii = loadExtents.length; i < ii; ++i) {
        var extent_1 = loadExtents[i];
        var userExtent_1 = (0, _proj.toUserExtent)(extent_1, projection);
        vectorSource.loadFeatures(userExtent_1, (0, _proj.toUserResolution)(resolution, projection), userProjection);
      }

      userTransform = (0, _proj.getTransformFromProjections)(userProjection, projection);
    } else {
      for (var i = 0, ii = loadExtents.length; i < ii; ++i) {
        vectorSource.loadFeatures(loadExtents[i], resolution, projection);
      }
    }

    var squaredTolerance = (0, _vector.getSquaredTolerance)(resolution, pixelRatio);

    var render =
    /**
     * @param {import("../../Feature.js").default} feature Feature.
     * @this {CanvasVectorLayerRenderer}
     */
    function (feature) {
      var styles;
      var styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();

      if (styleFunction) {
        styles = styleFunction(feature, resolution);
      }

      if (styles) {
        var dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, declutterBuilderGroup);
        this.dirty_ = this.dirty_ || dirty;
      }
    }.bind(this);

    var userExtent = (0, _proj.toUserExtent)(extent, projection);
    /** @type {Array<import("../../Feature.js").default>} */

    var features = vectorSource.getFeaturesInExtent(userExtent);

    if (vectorLayerRenderOrder) {
      features.sort(vectorLayerRenderOrder);
    }

    for (var i = 0, ii = features.length; i < ii; ++i) {
      render(features[i]);
    }

    this.renderedFeatures_ = features;
    var replayGroupInstructions = replayGroup.finish();
    var executorGroup = new _ExecutorGroup["default"](extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer());

    if (declutterBuilderGroup) {
      this.declutterExecutorGroup = new _ExecutorGroup["default"](extent, resolution, pixelRatio, vectorSource.getOverlaps(), declutterBuilderGroup.finish(), vectorLayer.getRenderBuffer());
    }

    this.renderedResolution_ = resolution;
    this.renderedRevision_ = vectorLayerRevision;
    this.renderedRenderOrder_ = vectorLayerRenderOrder;
    this.renderedExtent_ = renderedExtent;
    this.wrappedRenderedExtent_ = extent;
    this.renderedCenter_ = center;
    this.renderedProjection_ = projection;
    this.replayGroup_ = executorGroup;
    this.hitDetectionImageData_ = null;
    this.replayGroupChanged = true;
    return true;
  };
  /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [opt_transform] Transform from user to view projection.
   * @param {import("../../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
   * @return {boolean} `true` if an image is loading.
   */


  CanvasVectorLayerRenderer.prototype.renderFeature = function (feature, squaredTolerance, styles, builderGroup, opt_transform, opt_declutterBuilderGroup) {
    if (!styles) {
      return false;
    }

    var loading = false;

    if (Array.isArray(styles)) {
      for (var i = 0, ii = styles.length; i < ii; ++i) {
        loading = (0, _vector.renderFeature)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, opt_transform, opt_declutterBuilderGroup) || loading;
      }
    } else {
      loading = (0, _vector.renderFeature)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, opt_transform, opt_declutterBuilderGroup);
    }

    return loading;
  };

  return CanvasVectorLayerRenderer;
}(_Layer["default"]);

var _default = CanvasVectorLayerRenderer;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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